// components/ProductSelection/utils/constants.js

export const PRODUCT_TYPE_ENUM = [
  "GOLD",
  "SILVER",
  "PLATINUM",
  "DIAMOND",
  "STUDDED",
];

export const PRODUCT_STATUS_ENUM = ["ACTIVE", "INACTIVE", "DRAFT", "ARCHIVED"];

export const PRODUCT_SUBTYPE_ENUM = [
  "RING",
  "NECKLACE",
  "EARRING",
  "BRACELET",
  "PENDANT",
  "CHAIN",
  "BANGLE",
  "ANKLET",
  "NOSE_PIN",
  "MANGALSUTRA",
  "KADA",
  "COIN",
  "BAR",
  "IDOL",
  "OTHER",
];

export const PURITY_ENUM = ["24K", "22K", "18K", "14K", "925", "950", "PT950"];

export const METAL_COLOR_ENUM = [
  "YELLOW",
  "WHITE",
  "ROSE",
  "TWO_TONE",
  "THREE_TONE",
];
